import { Route, Routes, useNavigate } from "react-router-dom";
import FireOnListComponent from "components/fire-on/FireOnListComponent";
import AddFireOnItemComponent from "components/fire-on/AddFireOnItemComponent";
import NewFireOnItemComponent from "components/fire-on/NewFireOnItemComponent";
import DeleteFireOnItemComponent from "components/fire-on/DeleteFireOnItemComponent";
import FireInspectionScheduleComponent from "components/fire-on/FireInspectionScheduleComponent";
import AlarmSettingsComponent from "components/fire-on/AlarmSettingsComponent";
import BuildingDetailStatusComponent from "components/fire-on/BuildingDetailStatusComponent";
import BuildingEquipmentStatusComponent from "components/fire-on/BuildingEquipmentStatusComponent";
import UserStatusComponent from "components/fire-on/UserStatusComponent";
import FireAlarmMonitorComponent from "../components/fire-on/FireAlarmMonitorComponent";
import BoundaryMapComponent from "components/fire-on/BoundaryMapComponent";
import BuildingStatusComponent from "components/fire-on/BuildingStatusComponent";
import FireEquipmentStatusComponent from "components/fire-on/FireEquipmentStatusComponent";
import FireAlarmHistoryComponent from "components/fire-on/FireAlarmHistoryComponent";
import FireAlarmStatisticsComponent from "components/fire-on/FireAlarmStatisticsComponent";
import SMSHistoryListComponent from "components/fire-on/SMSHistoryListComponent";
import { useEffect, useState } from "react";
import useInterval from "utils/useInterval";
import { getDateTime } from "utils/date";
import FireOnHeader from "./FireOnHeader";

export default function FireOnPage() {
  const [currentDateTime, setCurrentDateTime] = useState("");

  useEffect(() => {
    handleSetCurrentDateTime();
  }, []);

  useInterval(() => {
    handleSetCurrentDateTime();
  }, 1000);

  const handleSetCurrentDateTime = () => {
    setCurrentDateTime(getDateTime(new Date()));
  };

  return (
    <Routes>
      <Route
        path="/*"
        element={
          <FireOnListComponent
            header={<FireOnHeader currentDateTime={currentDateTime} />}
          />
        }
      />
      <Route
        path="/add/*"
        element={
          <AddFireOnItemComponent
            header={<FireOnHeader currentDateTime={currentDateTime} />}
          />
        }
      />
      <Route
        path="/new/*"
        element={
          <NewFireOnItemComponent
            header={<FireOnHeader currentDateTime={currentDateTime} />}
          />
        }
      />
      <Route
        path="/new/:id/*"
        element={
          <NewFireOnItemComponent
            header={<FireOnHeader currentDateTime={currentDateTime} />}
          />
        }
      />
      <Route
        path="/delete/*"
        element={
          <DeleteFireOnItemComponent
            header={<FireOnHeader currentDateTime={currentDateTime} />}
          />
        }
      />
      <Route
        path="/fire-inspection-schedule/:id/*"
        element={
          <FireInspectionScheduleComponent
            header={<FireOnHeader currentDateTime={currentDateTime} />}
          />
        }
      />
      <Route
        path="/alarm-settings/:id/*"
        element={
          <AlarmSettingsComponent
            header={<FireOnHeader currentDateTime={currentDateTime} />}
          />
        }
      />
      <Route
        path="/building-detail-status/:id/*"
        element={
          <BuildingDetailStatusComponent
            header={<FireOnHeader currentDateTime={currentDateTime} />}
          />
        }
      />
      <Route
        path="/building-equipment-status/:id/*"
        element={
          <BuildingEquipmentStatusComponent
            header={<FireOnHeader currentDateTime={currentDateTime} />}
          />
        }
      />
      <Route
        path="/user-status/:id/*"
        element={
          <UserStatusComponent
            header={<FireOnHeader currentDateTime={currentDateTime} />}
          />
        }
      />
      <Route
        path="/alarm-monitor/:id/*"
        element={
          <FireAlarmMonitorComponent
            currentDateTime={currentDateTime}
          />
        }
      />
      <Route
        path="/boundary-map/:id/*"
        element={
          <BoundaryMapComponent
            currentDateTime={currentDateTime}
          />
        }
      />
      <Route
        path="/building-status/:id/*"
        element={
          <BuildingStatusComponent
            currentDateTime={currentDateTime}
          />
        }
      />
      <Route
        path="/equipment-status/:id/*"
        element={
          <FireEquipmentStatusComponent
            currentDateTime={currentDateTime}
          />
        }
      />
      <Route
        path="/alarm-history/:id/*"
        element={
          <FireAlarmHistoryComponent
            currentDateTime={currentDateTime}
          />
        }
      />
      <Route
        path="/alarm-statistics/:id/*"
        element={
          <FireAlarmStatisticsComponent
            currentDateTime={currentDateTime}
          />
        }
      />
      <Route
        path="/sms-history-list/:id/*"
        element={
          <SMSHistoryListComponent
            currentDateTime={currentDateTime}
          />
        }
      />
    </Routes>
  );
}
